import { ComponentProps } from 'react';

export function FacebookIcon({ className, ...props }: ComponentProps<'svg'>) {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
			<circle cx="15" cy="15" r="14.5" stroke="currentColor" />
			<path
				d="M18.0274 9.87404H19.3487V7H17.3614C14.5435 7 13.2081 8.67536 13.2081 11.0622V13.3229H11V16.0532H13.2046V22.9965H16.5168V16.0567H18.7214L19.3487 13.3264H16.5168V11.4618C16.5168 10.6977 16.9338 9.87404 18.0309 9.87404H18.0274Z"
				fill="currentColor"
			/>
		</svg>
	);
}
